var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { valueExist } from 'src/shared/helpers/objHelpers';
import './button.scss';
import { IDENTIFIER_BUTTON } from 'src/ui/components/button/constants';
import { Tooltip } from 'src/ui/components/ToolTip/Tooltip';
export var EButtonType;
(function (EButtonType) {
    EButtonType["NEUTRAL"] = "neutral";
    EButtonType["VALID"] = "valid";
    EButtonType["ABORT"] = "abort";
})(EButtonType || (EButtonType = {}));
export var Button = function (props) {
    var _a;
    var _b = props.type, type = _b === void 0 ? EButtonType.NEUTRAL : _b, label = props.label, title = props.title, href = props.href, rel = props.rel, target = props.target, classname = props.classname, leftIcon = props.leftIcon, disabled = props.disabled, _c = props.isEdge, isEdge = _c === void 0 ? false : _c, isLoading = props.isLoading, identifier = props.identifier, onClick = props.onClick;
    var buttonClass = classNames('button', (_a = {},
        _a[type] = !!type,
        _a[classname] = !!classname,
        _a.edge = isEdge,
        _a.disabled = !!disabled || !!isLoading,
        _a.withLeftIcon = !!valueExist(leftIcon),
        _a['is-loading'] = isLoading,
        _a));
    var handleOnClick = function (e) {
        e.stopPropagation();
        if (onClick && !disabled && !isLoading) {
            onClick();
        }
    };
    var buttonIdentifier = identifier ? identifier : IDENTIFIER_BUTTON;
    if (href) {
        return (_jsxs("a", __assign({ "data-test": buttonIdentifier, href: href, rel: rel, target: target, className: buttonClass, onClick: handleOnClick }, { children: [title && _jsx(Tooltip, { children: title }), valueExist(leftIcon) && _jsx(Icons, { icon: leftIcon }), label && _jsx("span", { children: label })] })));
    }
    return (_jsxs("button", __assign({ "data-test": buttonIdentifier, className: buttonClass, onClick: handleOnClick }, { children: [title && _jsx(Tooltip, { children: title }), valueExist(leftIcon) && _jsx(Icons, { icon: leftIcon }), label && _jsx("span", { children: label }), isLoading && _jsx("div", { className: 'button-loader' })] })));
};
